import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'aa-scroll',
    templateUrl: './scroll.component.html',
    styleUrls: ['./scroll.component.scss'],
    standalone: false
})
export class ScrollComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
